import React from 'react';
import { useTranslation } from 'react-i18next';
import { SESSION_STATUS } from '../../types/constants';
import { Dropdown, Button } from '../ui';
import { ArrowUp, ArrowDown } from 'lucide-react';

interface SessionFiltersProps {
  filters: {
    status: string;
    dateRange: {
      start: Date | null;
      end: Date | null;
    };
  };
  onFilterChange: (filters: {
    status: string;
    dateRange: {
      start: Date | null;
      end: Date | null;
    };
  }) => void;
  onSortChange: (column: string, direction: 'asc' | 'desc') => void;
  sortColumn: string;
  sortDirection: 'asc' | 'desc';
}

export const SessionFilters: React.FC<SessionFiltersProps> = ({
  filters,
  onFilterChange,
  onSortChange,
  sortColumn,
  sortDirection,
}) => {
  const { t } = useTranslation();

  const statusOptions = [
    { value: 'all', label: t('sessionFilters.status.all') },
    { value: SESSION_STATUS.SCHEDULED, label: t('sessionFilters.status.scheduled') },
    { value: SESSION_STATUS.COMPLETED, label: t('sessionFilters.status.completed') },
    { value: SESSION_STATUS.CANCELLED, label: t('sessionFilters.status.cancelled') },
    { value: SESSION_STATUS.NO_SHOW, label: t('sessionFilters.status.noShow') },
    { value: SESSION_STATUS.INVOICED, label: t('sessionFilters.status.invoiced') },
  ];

  const sortOptions = [
    { value: 'sessionDateTime', label: t('sessionFilters.sort.date') },
    { value: 'status', label: t('sessionFilters.sort.status') },
  ];

  const onSortDirectionChange = () => {
    onSortChange(sortColumn, sortDirection === 'asc' ? 'desc' : 'asc');
  };

  return (
    <div className="flex flex-col sm:flex-row flex-wrap gap-4">
      <Dropdown
        label={t('sessionFilters.status.label')}
        options={statusOptions}
        value={filters.status}
        onChange={(value) => onFilterChange({ ...filters, status: value })}
        className="w-full sm:w-auto md:w-48"
        aria-label={t('sessionFilters.status.label')}
      />
      <div className="flex items-end space-x-2">
        <Dropdown
          label={t('sessionFilters.sort.label')}
          options={sortOptions}
          value={sortColumn}
          onChange={(value) => onSortChange(value, sortDirection)}
          className="w-full sm:w-auto md:w-48"
          aria-label={t('sessionFilters.sort.label')}
        />
        <Button
          variant="secondary"
          onClick={onSortDirectionChange}
          className="h-[46px] px-3"
          title={t('sessionFilters.sort.toggleDirection')}
        >
          {sortDirection === 'asc' ? (
            <ArrowUp className="w-4 h-4" />
          ) : (
            <ArrowDown className="w-4 h-4" />
          )}
        </Button>
      </div>
    </div>
  );
}; 